import { useMutation } from '@tanstack/react-query'
import { useApiFetch } from '../../../shared/api/useApiFetch'
import { refreshUntilImpersonation } from '../../../shared/auth/refreshAuthToken'

/**
 * Calls DELETE /api/v1/authentication/impersonate, then force-refreshes the Firebase
 * ID token until the `impersonating` custom claim is actually gone (it is eventually
 * consistent — a single refresh can still carry the stale claim, which is why the
 * banner used to persist and the user got stuck), and hard-reloads.
 */
export function useStopImpersonation() {
  const call = useApiFetch()
  return useMutation({
    mutationFn: async () => {
      await call<void>('/api/v1/authentication/impersonate', { method: 'DELETE' })
    },
    onSuccess: async () => {
      try {
        await refreshUntilImpersonation(false)
      } catch {
        // token refresh failed; reload anyway so the server issues a fresh token on next auth
      }
      window.location.assign('/')
    },
  })
}
